module.exports = __webpack_public_path__ + "img/1507085244.dc48b547.jpg";